var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightShiftCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11620",
    "data-name": "Group 11620",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    fill: "#fff",
    stroke: "#393939",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.75,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11619",
    "data-name": "Group 11619",
    transform: "translate(9.825 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M16.263,12.467,11.514,7.722a.9.9,0,1,1,1.27-1.267l5.38,5.376a.9.9,0,0,1,.026,1.237l-5.4,5.414a.9.9,0,1,1-1.27-1.267Z",
    transform: "translate(-5.251 -6.194)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back-2",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M16.263,12.467,11.514,7.722a.9.9,0,1,1,1.27-1.267l5.38,5.376a.9.9,0,0,1,.026,1.237l-5.4,5.414a.9.9,0,1,1-1.27-1.267Z",
    transform: "translate(-11.251 -6.194)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightShiftCircle);
export default __webpack_public_path__ + "static/media/rightShiftCircle.f7dff341ae8329d945957c7ac8a23d79.svg";
export { ForwardRef as ReactComponent };